export default __webpack_public_path__ + "static/media/visa_inverse.d679d4f1.svg";